<template>
  <div class="container">
    <template v-if="reenrollmentBill.id">
      <div class="row">
        <div class="col-md-8 col-md-offset-2">
          <div class="bsd-section">
            <breadcrumb />
          </div>

          <div class="bsd-section">
            <payment-value-card
              :reenrollment="currentReenrollment"
            />

            <div class="z-title z-title--small spacer-bottom-l">
              Escolha a forma de pagamento
            </div>

            <div class="reenrollment-payment-methods-wrapper">
              <action-card
                v-if="allowCardPayment"
                title="Cartão de Crédito"
                icon="credit-card-blank"
                class="reenrollment-payment-methods__action-card"
                @click="goToCreditCard()"
              />

              <action-card
                v-if="allowBoletoPayment"
                title="Boleto"
                icon="barcode-alt"
                class="reenrollment-payment-methods__action-card"
                @click="goToBoleto()"
              />

              <action-card
                v-if="allowPixPayment"
                title="Pix"
                icon="qrcode"
                class="reenrollment-payment-methods__action-card"
                @click="goToPix()"
              />
            </div>
          </div>

          <div class="z-title z-title--small spacer-bottom-m">
            Está com dúvidas sobre os pagamentos do semestre?

            <accordion title="Mostrar previsão dos pagamentos">
              <prevision-bills
                :reenrollment="currentReenrollment"
              />
            </accordion>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.reenrollment-payment-methods-wrapper {
  display: flex;
}

.reenrollment-payment-methods__action-card {
  flex: 1;
  height: 144px;

  &:first-child {
    margin-right: var(--space-medium);
  }

  &:last-child {
    margin-left: var(--space-medium);
  }
}

.reenrollment-value__card--disabled {
  opacity: 0.7;
}
</style>

<script>
import { mapState, mapActions } from 'vuex';
import Accordion from 'components/accordion';
import ActionCard from 'components/action-card';
import Breadcrumb from 'components/breadcrumb';
import PrevisionBills from './prevision-bills';
import PaymentValueCard from './payment-value-card.vue';

export default {
  components: {
    Accordion,
    ActionCard,
    Breadcrumb,
    PaymentValueCard,
    PrevisionBills,
  },
  computed: {
    ...mapState([
      'currentReenrollment',
    ]),

    allowCardPayment() {
      return this.includesPaymentMethod('credit_card');
    },

    allowBoletoPayment() {
      return this.includesPaymentMethod('boleto');
    },
    allowPixPayment() {
      return this.includesPaymentMethod('pix');
    },
    hasFee() {
      return this.currentReenrollment.fee_type === 'reenrollment_fee';
    },
    isAmountWithoutDiscount() {
      return this.currentReenrollment.fee_type === 'first_bill_without_discount';
    },
  },
  data() {
    return {
      reenrollmentBill: {},
    };
  },
  methods: {
    ...mapActions([
      'loadReenrollment',
    ]),
    includesPaymentMethod(paymentMethod) {
      if (this.currentReenrollment.payment_methods instanceof Array) {
        return this.currentReenrollment.payment_methods.includes(paymentMethod);
      }

      return false;
    },
    goToCreditCard() {
      this.$tracker.logEvent('[reenrollment] Clicked "Pagar com cartão de crédito"');
      this.$router.push({ name: 'reenrollment-credit-card', params: { billId: this.reenrollmentBill.id } });
    },
    goToBoleto() {
      this.$tracker.logEvent('[reenrollment] Clicked "Pagar com boleto"');
      this.$router.push({ name: 'reenrollment-boleto', params: { billId: this.reenrollmentBill.id } });
    },
    goToPix() {
      this.$tracker.logEvent('[reenrollment] Clicked "Pagar com pix"');
      this.$router.push({ name: 'reenrollment-pix', params: { billId: this.reenrollmentBill.id } });
    },
  },

  mounted() {
    this.$tracker.logEvent('Viewed Reenrollment Page');
  },

  created() {
    this.$pageLoader.show('Buscando rematrículas');
    this.loadReenrollment()
      .then((reenrollment) => {
        if (reenrollment.bill) {
          this.reenrollmentBill = reenrollment.bill;
        }
      })
      .finally(() => {
        this.$pageLoader.hide();
        if (
          !this.currentReenrollment.id
          || !['waiting_reenrollment_payment'].includes(this.currentReenrollment.status)
        ) {
          this.$router.push({ name: 'panel' });
        }
      });
  },
};
</script>
